export const alertsSelector = (state) => ({
  alerts: state.alerts
});
